var _rect, _path, _path2, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalUploadScv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#E75B32",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2355 38.3125L47.8296 36.7125C47.4413 36.2709 46.7693 36.2283 46.3256 36.6144L42.1336 40.288V25.0667C42.1336 24.4779 41.6557 24 41.0669 24H38.9336C38.3448 24 37.8669 24.4779 37.8669 25.0667V40.288L33.6749 36.6144C33.2333 36.2283 32.5613 36.2709 32.1709 36.7125L30.7651 38.3104C30.3747 38.7541 30.4195 39.4304 30.8632 39.8187L39.2984 47.2021C39.7016 47.5541 40.3011 47.5541 40.7043 47.2021L49.1373 39.8187C49.5811 39.4304 49.6259 38.7541 49.2355 38.3125Z",
    fill: "#E75B32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7335 51.7324H28.2668C27.678 51.7324 27.2001 52.2103 27.2001 52.7991V54.9324C27.2001 55.5212 27.678 55.9991 28.2668 55.9991H51.7335C52.3223 55.9991 52.8001 55.5212 52.8001 54.9324V52.7991C52.8001 52.2103 52.3223 51.7324 51.7335 51.7324Z",
    fill: "#E75B32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#E75B32",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalUploadScv);
export default __webpack_public_path__ + "static/media/modal-upload-scv.ee2c4523.svg";
export { ForwardRef as ReactComponent };